import React from 'react';
import styled from 'styled-components';
import {Toolbar} from '../../common/Toolbar';
import {selectListComponent} from '../../components/Components';
import {Component} from '../../types/Schema';
import {ToolButton} from '../../types/ToolButton';

type Props = {
  buttons?: ToolButton[];
  farButtons?: ToolButton[];
  mappings: {[key: string]: any};
  sorterId: string;
  sortOrderDesc: boolean;
  components: {
    [area: string]: Component;
  };
};

export function ListHeader(props: Props): JSX.Element {
  return (
    <Container>
      <Toolbar
        buttons={buildListButtons(props, props.buttons)}
        farButtons={buildListButtons(props, props.farButtons)}
      />
    </Container>
  );
}

export const Container = styled.div``;

function buildListButtons(props: Props, buttons?: ToolButton[]) {
  if (!buttons) {
    return [];
  }

  const list = selectListComponent(props.components);
  const sorters = list ? list.sorters : [];

  buttons.forEach((button) => {
    if (button.type === 'sort') {
      if (!button.sorters) {
        button.sorters = sorters;
      }

      button.currentSort = {
        sorterId: props.sorterId,
        desc: props.sortOrderDesc,
      };
    }

    button.onClick = props.mappings[button.type];
  });

  return buttons;
}
